import { env } from "env";

/**
 * Configuration du proxy d'authentification
 */

const getProxyConfig = () => {
  // URL du proxy depuis les variables d'environnement
  // React injecte automatiquement les variables REACT_APP_* dans process.env
  let proxyUrl = env.proxy_url;
  const host = window.location?.host;
  const proxyVersion =localStorage.getItem('proxy') ?? 'default';
  if (proxyVersion === 'default') {
    if (host.includes('.atlantic-pros.fr')) {
      proxyUrl = env.proxy_atlantic_url;
    } else if (host.includes('.thermor.fr')) {
      proxyUrl = env.proxy_thermor_url;
    } else if (host.includes('.plateforme-services.com')) {
      proxyUrl = env.proxy_plateforme_service_url;
    } else if (host.includes('.spareparts-app.com')) {
      proxyUrl = env.proxy_spareparts_app_url;
    } else if (host.includes('.pacific-pros.fr')) {
      proxyUrl = env.proxy_pacific_url;
    } 
  }
      


  // console.log('🔧 Configuration Proxy:', {
  //   'REACT_APP_PROXY_URL from env': env.proxy_url,
  //   'proxyUrl used': proxyUrl,
  //   'all env vars': env.getAllKeys()
  // });

  return {
    baseUrl: proxyUrl,
    endpoints: {
      login: `${proxyUrl}/auth/login`,
      status: `${proxyUrl}/auth/status`,
      logout: `${proxyUrl}/auth/logout`,
      api: `${proxyUrl}/api`
    }
  };
};

export const proxyConfig = getProxyConfig();

export default proxyConfig;
